<template>
  <div class="produto">
    <div class="categorias">Produto(s)</div>
    <div class="items">
      <table>
        <thead>
          <th class="item-title">Codigo do Produto</th>
          <th class="item-title">Descrição</th>
          <!-- <th class="item-title">Modelo</th> -->
          <th class="item-title">Código de Materia Prima</th>
          <th class="item-title">Descrição da Materia Prima</th>
        </thead>
        <tbody>
          <tr v-for="l in dataProdutos" :key="l.ID">
            <td>{{ l.COD_PRODUTO }}</td>
            <td>{{ l.DESC_PRODUTO }}</td>
            <!-- <td >{{l.MODELO}}</td> -->
            <td>{{ l.COD_MATERIA_PRIMA }}</td>
            <td>{{ l.DESC_MATERIA_PRIMA }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataProdutos: "",
  },
};
</script>

<style>
table {
  width: 100%;
  text-align: center;
  border: none;
  font-size: 10px;
  border-collapse: collapse;
  border-spacing: 0;
}
</style>
